$shm_hitalama_notifications $mol_view
	sub <= rows /
		<= Row* $mol_view
			sub /
				<= Card* $mol_view
					attr *
						^
						notification_type <= type* \info
					sub /
						<= Content* $mol_view
							sub /
								<= Title_holder* $mol_view
									sub <= notification_title_visible* /
										<= Title* $mol_view
											sub / <= notification_title* \
								<= Message* $mol_view
									sub / <= message* \
								<= Details_holder* $mol_view
									sub <= details_visible* /
										<= Details_row* $mol_view
											sub /
												<= Details* $mol_view
													sub / <= details* \
												<= Copy* $mol_button_minor
													hint \Копировать ошибку
													click? <=> copy*? null
													sub /
														<= Copy_icon* $mol_icon_content_copy
						<= Close* $mol_button_minor
							hint \Закрыть
							click? <=> close*? null
							sub /
								<= Close_icon* $mol_icon_close
